import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Image } from 'grommet'
import { qlikBrand } from '../../branding'
import logo from '../../locman_logo.png'
import { signOut } from 'aws-amplify/auth';

const Header = ({ size, status }) => {  
  const labels = {
    uiBus: 'BUS',
    repositories: 'REPOSITORIES',
    uiBugfix: 'BUGFIX',
    queries: 'QUERIES',
    quotes: 'QUOTES',
    logout: 'LOGOUT'
  }

  const { bugfix, query, ui } = status
  let buttonColors = {}
  if (bugfix) { buttonColors.bugfix = qlikBrand.flood.turquoise }
  else { buttonColors.bugfix = 'red'}
  if (query) { buttonColors.query = qlikBrand.flood.turquoise }
  else { buttonColors.query = 'red'}
  if (ui) { buttonColors.ui = qlikBrand.flood.turquoise }
  else { buttonColors.ui = 'red'}
  
  if (size === 'medium') {
    return (
      <Box justify='between' align='center'>
        <Box align='center' fill>
          <Box height='xsmall' width='small'>
            <Image fit='contain' src={logo} />
          </Box>
        </Box>
        <Box direction='row-responsive' gap='medium' justify='center' align='center' fill>
          <Button primary color={buttonColors.ui} label={labels.uiBus} href="/" />
          <Button primary color={buttonColors.bugfix} label={labels.uiBugfix} href='/bugfix' />
          <Button primary color={buttonColors.query} label={labels.queries} href='/queries' />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.quotes} href='/quotes'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.repositories} href='/repositories'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.logout} onClick={() => signOut()} />
        </Box>

      </Box>
    )
  }
  if (size === 'large') {
    return (
      <Box direction='row' justify='between' align='center'>
        <Box fill>
          <Box height='xsmall' width='small'>
            <Image fit='contain' src={logo} />
          </Box>
        </Box>
        <Box direction='row-responsive' gap='medium' justify='center' align='center' fill>
          <Button primary color={buttonColors.ui} label={labels.uiBus} href="/" />
          <Button primary color={buttonColors.bugfix} label={labels.uiBugfix} href='/bugfix' />
          <Button primary color={buttonColors.query} label={labels.queries} href='/queries' /> 
          <Button primary color={qlikBrand.flood.turquoise} label={labels.quotes} href='/quotes'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.repositories} href='/repositories'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.logout} onClick={() => signOut()} />
        </Box>
        <Box direction='row-responsive' gap='medium' justify='end' align='center' fill='horizontal' />
      </Box>
    )
  } else {
    return (
      <Box align='center' gap='medium' fill>
        <Box height='xsmall' width='small'>
          <Image fit='contain' src={logo} />
        </Box>
        <Box gap='medium' justify='center' align='center' fill>
          <Button primary color={buttonColors.ui} label={labels.uiBus} href="/" />
          <Button primary color={buttonColors.bugfix} label={labels.uiBugfix} href='/bugfix' />
          <Button primary color={buttonColors.query} label={labels.queries} href='/queries' />  
          <Button primary color={qlikBrand.flood.turquoise} label={labels.quotes} href='/quotes'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.repositories} href='/repositories'  />
          <Button primary color={qlikBrand.flood.turquoise} label={labels.logout} onClick={() => signOut()} />
        </Box>
      </Box>
    )
  }
}

Header.propTypes = {
  size: PropTypes.string.isRequired,
  status: PropTypes.object.isRequired
}

export default Header

